module.exports = __webpack_public_path__ + "static/media/GCP_firstPage_ko.3d1ca0c2.png";